export const baseURL = "https://livefix.skhlive.fun/";
// export const baseURL = "http://192.168.29.19:5000/";
export const key = "L0]?/7Wf=[VS}L@FKk`_#^pnd]:v@M";

